import { useState, useEffect } from "react";

import { useDispatch, useSelector } from "react-redux";
import { endPoints } from "../../config/end-points";
import { getSubdomain } from "../../helpers/helpers";
import useHttp from "../../hooks/use-http";
import { authActions } from "../../store/auth";
import { templateAction } from "../../store/template-store";
import SingleTemplate from "./SingleTemplate";

const TemplateList = (props) => {
  const [templates, setTemplates] = useState([]);

  const dispatch = useDispatch();

  const { sendRequest } = useHttp();
  const { sendRequest: makeFavTempRequest } = useHttp();

  const is_loaded = useSelector((state) => state.template.is_loaded);
  const token = useSelector((state) => state.auth.token);
  const defaultTemplate = useSelector((state) => state.template.template_data);
  const ez_sid = useSelector((state) => state.ezleadzStore.subdomain_id);
  const myAccess = useSelector((state) => state.auth.access);

  const checkaccess =  (access) => myAccess.includes(access); 

  // console.log(props.showFav);
  useEffect( () => {
    const responseData = (response) => {
      // console.log(response.body);

      if (response.body) {
        // console.log(response.body);
        // setTemplates("Hello");
        if(ez_sid){
          // console.log("ez_sid");
          const display_template_by_order = response.body.filter(template => template.display_order === 1);
          const display_template_all = response.body.filter(template => template.display_order !== 1);
          // console.log(display_template_by_order);
          const all_available_templates = [...display_template_by_order, ...display_template_all];

          setTemplates(all_available_templates);

          dispatch(templateAction.setTemplateData({ template_data: all_available_templates }));
        }else{
          // console.log("else_sid");
          if(myAccess.includes("5") || myAccess.includes("9A")){
            
            setTemplates(response.body);
            dispatch(templateAction.setTemplateData({ template_data: response.body }));
          }else if(myAccess.includes("8A") || myAccess.includes("8B") || myAccess.includes("1a") ){
            
            console.log(response.body);
            setTemplates(response.body);
            dispatch(templateAction.setTemplateData({ template_data: response.body }));
          }else if(myAccess.includes("5") || myAccess.includes("8B") || myAccess.includes("3A-")){
            
            const display_template_by_order = response.body.filter(template => template.display_order === 311 && template.status === 1);
            const display_template_all = response.body.filter(template => template.display_order !== 311 && template.display_order <311);
            // console.log(display_template_by_order);
            const all_available_templates = [...display_template_by_order, ...display_template_all];

            const dispay_other_template = response.body.filter( (template) => template.display_order > 311 && template.access.split(',').filter(Boolean).some(checkaccess) && template.status === 1);
            const new_display_template_all = [...all_available_templates, ...dispay_other_template];
  
            setTemplates(new_display_template_all);
            dispatch(templateAction.setTemplateData({ template_data: new_display_template_all }));
          }else if(myAccess.includes("1A") || myAccess.includes("2A")){
            
            let dispay_template_by_access = [];
            response.body.filter((template, index, array) => {

              if(template.access !== null){
                let t_access = template.access.split(',').filter(Boolean);
                let m_access = myAccess.split(',').filter(Boolean);
                let common = t_access.filter(value => m_access.includes(value));
                if(common.length > 0){ dispay_template_by_access.push(template); }
              }
              
              if (index === array.length - 1) {
                // console.log(dispay_template_by_access);
                setTemplates(dispay_template_by_access);
                dispatch(templateAction.setTemplateData({ template_data: dispay_template_by_access }));
              }
              return true;
            });

            // console.log(dispay_template_by_access);
            // setTemplates(dispay_template_by_access);
            // dispatch(templateAction.setTemplateData({ template_data: dispay_template_by_access }));
          }

        }
        // console.log(myAccess);
      }
      dispatch(authActions.setLoaderStatus({ status: false }));
    };

    if (!is_loaded) {

      var productName = getSubdomain();

      if(productName === "vidwise" || productName === "nicheflick"){
        productName = "vidcraftai";
      }


      dispatch(authActions.setLoaderStatus({ status: true }));
      // console.log("subdomain_name",subdomain_name);
      const apiUrl = productName ? endPoints.fetchTemplates + "/" + productName : endPoints.fetchTemplates;
      sendRequest(
        {
          url: apiUrl,
          method: "GET",
          headers: {
            "access-control-allow-origin": "*",
            "Content-Type": "application/json",
            Authorization: "Bearer " + token,
          },
        },
        responseData
      );
    } 
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dispatch, is_loaded, sendRequest, setTemplates, defaultTemplate,token,ez_sid,props.subdomain_name]);

  useEffect(() => {
    if (
      is_loaded &&
      defaultTemplate &&
      templates.length === 0 &&
      props.showFav === 0
    ) {
      setTemplates(defaultTemplate);
    }
  }, [is_loaded, defaultTemplate, templates, props.showFav]);

  const handleTemplateId = (id) => {
    props.templateId(id);
  };

  const [ handlesss, setHandlesss ] = useState(0);

  useEffect(() => {

    var getKeyword = localStorage.getItem('keyword');

    if( getKeyword !== null && getKeyword !== "" && getKeyword !== undefined && handlesss === 0 ){
      getKeyword = getKeyword.replace(/['"]+/g, '');
      getKeyword = getKeyword.toLowerCase();
      // props.setSearch_temp(getKeyword);
      setHandlesss(1);
    }
    // eslint-disable-next-line
  },[]);

  const handleMakeFav = (template_id, is_fav) => {
    // console.log(template_id, is_fav, "akash");
    const isFav = is_fav ? 0 : 1;

    const dummyTemp = defaultTemplate.map((template) => {
      var temp = { ...template };

      if (template.id === template_id) {
        temp.fav = isFav;
      }

      return temp;
    });

    makeFavTempRequest({
      url: isFav ? endPoints.makeFav : endPoints.removeFav,
      method: "POST",
      headers: {
        "access-control-allow-origin": "*",
        "Content-Type": "application/json",
        Authorization: "Bearer " + token,
      },
      body: {
        template_id,
        isFav,
      },
    });
    setTemplates(dummyTemp);
    dispatch(templateAction.setTemplateData({ template_data: dummyTemp }));

    if (props.showFav === 1) {
      const favTemp = dummyTemp.filter((template) => template.fav > 0);
      setTemplates(favTemp);
    }
  };

  useEffect(() => {
    if (props.showFav === 1) {
      const favTemp = templates.filter((template) => template.fav > 0);
      setTemplates(favTemp);
    } else {
      setTemplates([]);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.showFav]);

  useEffect(() => {
    
    if(is_loaded){
      if( props.select_temp_type !== 'All'){
        const sl_temp =  defaultTemplate.filter((template) => template.temp_type === props.select_temp_type )
        setTemplates(sl_temp);
  
      }else{
        setTemplates(defaultTemplate);
      }
    }

    console.log(props.select_temp_type);
    
    // eslint-disable-next-line
  }, [props.select_temp_type , is_loaded]);


  const filteredTemplates = templates.filter((template) =>
    (template.temp_type === props.select_temp_type || props.select_temp_type === 'All') &&
    (template.status === 1 || (myAccess.includes("5") || myAccess.includes("9S"))) &&
    (props.search_temp === "" ||
      (template.name.toLowerCase().includes(props.search_temp.toLowerCase()) ||
       template.name.includes('Universal')))
  );
  
  return (
    <>
      {filteredTemplates.length > 0 ? (
        filteredTemplates.map((template) => (
          <SingleTemplate
            key={template.id}
            id={template.id}
            main_temp_id={template.main_id}
            templateId={handleTemplateId}
            name={template.name}
            preview_url={template.preview_url}
            thumbnail_url={template.thumbnail_url}
            is_fav={template.fav ? 1 : 0}
            selectedTemp={props.selectedTemp}
            template_type={template.temp_type}
            makeIsfav={(e) =>
              handleMakeFav(template.id, template.fav ? 1 : 0)
            }
          />
        ))
      ) : (
        <p>No templates found for this search</p>
      )}
    </>
  );
}  

export default TemplateList;
